module.exports = __webpack_public_path__ + "static/noise_1.4cc7cc0b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/navigation/noise_1.gif
// module id = 688
// module chunks = 213534597649335